import { Component, OnInit, OnDestroy, AfterViewInit, ElementRef, ViewChild, HostListener, ViewChildren, QueryList, Directive } from "@angular/core";
import { Subscription, concat, throwError } from 'rxjs';
import { DirectionService } from '../../direction.service';
import { TranslateService } from '@ngx-translate/core';

import { trigger, transition, style, animate, state } from '@angular/animations';
import { timer } from 'rxjs';
import { take, map, filter } from 'rxjs/operators';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { UsersService } from '../../super-management/user/users.service';
import { FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { AuthService } from '../../auth/auth.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { getMapTilerStyleUrl } from 'src/app/maptiler/maptiler-style-url';
import lottie from 'lottie-web';

@Directive({
  selector: '[appPhoneFormatHome]'
})
export class PhoneFormatHomeDirective {
  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event) {
    const initialValue = this.el.nativeElement.value;
    this.el.nativeElement.value = initialValue
      .replace(/[^0-9]/g, '')
      .replace(/(\d{2})(\d{4})(\d{3})/, '0$1-$2-$3');
    if (initialValue !== this.el.nativeElement.value) {
      event.stopPropagation();
    }
  }
}

import * as maplibregl from 'maplibre-gl';

import { ClustersService } from '../../main-section/choose-branch/clusters.service';
import { retry, catchError } from 'rxjs/operators';
import { DataSharingService } from '../../main-section/data-shering-service/data-sharing.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  host: {
    class: 'fill-screen'
  },
  animations: [
    trigger('slideInOut', [
      state('in', style({ transform: 'translateX(0%) scale(1.0)', opacity: 1 })),
      state('out', style({ transform: 'translateX(5%) scale(0.9)', opacity: 0 })),
      transition('out => in', [
        style({ transform: 'translateX(-15%) scale(0.9)' }),
        animate('150ms ease-in', style({ transform: 'translateX(0%) scale(1.0)', opacity: 1 }))
      ]),
      transition('in => out', [
        animate('20ms 150ms', style({ transform: 'translateX(15%) scale(0.9)', opacity: 0 }))
      ])
    ]),
    trigger('expandHeight', [
      transition(':enter', [
        style({ maxHeight: '0', overflow: 'hidden', opacity: 0 }),
        animate('800ms ease-in-out', style({ maxHeight: '2000px', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('800ms ease-in-out', style({ maxHeight: '0', overflow: 'hidden', opacity: 0 }))
      ])
    ])
  ]
})

export class HomeComponent implements OnInit, OnDestroy, AfterViewInit {
  isRTL: boolean = true;
  private directionSubscription: Subscription;
  private routerSubscription: Subscription;
  isDarkMode: boolean = false;
  isLoading = false;

  userId: string;
  userIsAuthenticated = false;

  imgDevice: string;
  devices = ['sketch', 'doc', 'img'];
  deviceIndex = 0;
  typedText = '';
  typing = false;
  typedTextDevice = '';

  imgService: string;
  services = ['express', 'pics', 'plotter'];

  @ViewChild('videoPlayer') videoPlayer: ElementRef;
  @ViewChild('scrollContainer') scrollContainer: ElementRef;
  @ViewChild('businessExplainText2', { static: false }) businessExplainText2: ElementRef;
  @ViewChild('businessFormContainer', { static: false }) businessFormContainer: ElementRef;
  private initialized = false;
  isAnimatingSteps: boolean = false;
  animatingStep: number = 0;
  animationInterval: any;
  scrollTop: number = 0;
  fullHeight: number = 0;

  isScreenWide: boolean = window.innerWidth > 992;

  // MAP

  private map: any;
  isMapMode: boolean = false;
  isMoreInfoPH: boolean = false;

  // map
  @ViewChildren('mapBranchItem') mapBranchItems: QueryList<ElementRef>;
  mapContainerWidth: number = 0;
  mapContainerHeight: number = 0;
  public filteredBranches: any[] = [];
  branchesMapLocationsList: any[] = [];
  resizeObserver: any;
  zoom: number = 8;
  private markerElements: HTMLElement[] = [];

  clusterName: string = '';
  filteredClusters: any[] = [];
  clusters: any[] = [];
  
  isBusinessMode: boolean = false;
  
  // Business form
  showBusinessForm: boolean = false;
  businessForm: FormGroup;
  userEmail: string = '';
  userPhone: string = '';
  isSubmittingForm: boolean = false;
  showSuccessMessage: boolean = false;
  showFieldsNotCompleteMessage: boolean = false;
  fieldsNotCompleteTimeout: any;
  formContainerHeight: number = 0;
  animation: any;
  successTimeout: any;

  constructor(
    private directionService: DirectionService,
    private translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private usersService: UsersService,
    private clustersService: ClustersService,
    private dataSharingService: DataSharingService,
    private authService: AuthService,
    private http: HttpClient
  ) { }

  ngOnInit() {
    this.isLoading = true;
    if (this.scrollContainer) {
      this.scrollContainer.nativeElement.scrollTop = 0;
    }

    // Check if we're in business mode based on URL (/joinus or /joinus/en etc.)
    this.isBusinessMode = this.router.url === '/joinus' || this.router.url.startsWith('/joinus/');

    // `/home/en`, `/joinus/en` (param "lang") – שפה/כיוון/תרגום. `/en` נמצא ב-ChooseBranch, לא כאן.
    const applyHomeLanguageFromRoute = () => {
      const snap = this.route.snapshot;
      const fromData = snap.data['homeLang'] as string | undefined;
      const fromParam = snap.paramMap.get('lang');
      const lang = (fromData || fromParam || '').trim() || null;
      if (lang) {
        this.directionService.toLanguageDirection(lang);
        if (this.userIsAuthenticated) {
          this.usersService.updateUserLanguage(lang);
        }
      }
    };
    applyHomeLanguageFromRoute();
    this.route.paramMap.subscribe(() => applyHomeLanguageFromRoute());
    this.route.data.subscribe(() => applyHomeLanguageFromRoute());

    this.directionSubscription = this.directionService.direction$.subscribe(direction => {
      this.isRTL = direction === 'rtl';
    });

    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const wasBusinessMode = this.isBusinessMode;
        this.isBusinessMode = event.urlAfterRedirects === '/joinus' || event.urlAfterRedirects.startsWith('/joinus/');
        // Reset device index when switching modes
        if (wasBusinessMode !== this.isBusinessMode) {
          this.deviceIndex = 0;
        }
        // Initialize business form if entering business mode
        if (this.isBusinessMode && !this.businessForm) {
          this.initBusinessForm();
          // Get user email and phone if authenticated
          if (this.userIsAuthenticated) {
            this.authService.email$.subscribe(email => {
              this.userEmail = email || '';
              if (this.businessForm) {
                this.businessForm.patchValue({ email: this.userEmail });
              }
            });
            
            const userId = this.authService.getUserId();
            if (userId) {
              this.usersService.getUser(userId).subscribe((user: any) => {
                if (user && user.phone) {
                  this.userPhone = this.formatPhoneNumber(user.phone);
                  if (this.businessForm) {
                    this.businessForm.patchValue({ phone: this.userPhone });
                  }
                }
              });
            }
          }
        }
      });

    this.directionService.isDarkMode$.subscribe(isDarkMode => {
      // this.isDarkMode = isDarkMode;
    });

    this.startDeviceTimer();

    this.startStepsAnimation();
    
    // Initialize business form only if in business mode
    if (this.isBusinessMode) {
      this.initBusinessForm();
      
      // Get user email and phone if authenticated
      if (this.userIsAuthenticated) {
        this.authService.email$.subscribe(email => {
          this.userEmail = email || '';
          if (this.businessForm) {
            this.businessForm.patchValue({ email: this.userEmail });
          }
        });
        
        const userId = this.authService.getUserId();
        if (userId) {
          this.usersService.getUser(userId).subscribe((user: any) => {
            if (user && user.phone) {
              this.userPhone = this.formatPhoneNumber(user.phone);
              if (this.businessForm) {
                this.businessForm.patchValue({ phone: this.userPhone });
              }
            }
          });
        }
      }
    }

    this.isLoading = false;

    this.clustersService
      .getClusters()
      .pipe(
        retry(3),
        catchError((error) => {
          console.error('Failed to fetch clusters after 3 attempts:', error);
          window.location.href = 'https://print.eazix.io';
          return throwError(error);
        })
      )
      .subscribe((clusters) => {
        this.clusters = clusters;
        this.filteredClusters = clusters;
        this.isLoading = false;
        this.updateBranchesMapLocationsList(clusters);
      });
  }

  private updateBranchesMapLocationsList(clusters: any[]) {
    this.branchesMapLocationsList = clusters.map(cluster => {
      const obj: any = {
        name: cluster.serial_name || '',
        location: {
          lon: cluster.place.lon,
          lat: cluster.place.lat
        },
        top: cluster.place.top
      };
      if (cluster.time && cluster.time !== 0) {
        obj.time = cluster.time;
      }
      return obj;
    });
  }

  // private playVideo = () => {
  //   if (this.videoPlayer.nativeElement.paused) {
  //     this.videoPlayer.nativeElement.playbackRate = 1;
  //     this.videoPlayer.nativeElement.play();
  //   }
  // };

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.isScreenWide = window.innerWidth > 992;
  }

  ngAfterViewInit(): void {
    // Initialize Lottie animation
    setTimeout(() => {
      const animationContainer = document.getElementById('businessFormSuccessAnimation');
      if (animationContainer) {
        this.animation = lottie.loadAnimation({
          container: animationContainer,
          renderer: 'svg',
          loop: false,
          autoplay: false,
          path: 'assets/videos/successfully.json',
        });
        this.animation.setSpeed(2.6);
      }
    }, 0);

    if (this.scrollContainer && !this.initialized) {
      this.initialized = true;

      // GOOGLE MAPS
      setTimeout(() => {
        const mapDiv = document.getElementById('map');
        console.log('mapDiv', mapDiv);
        if (!mapDiv) return;

        this.map = new maplibregl.Map({
          container: mapDiv,
          style: getMapTilerStyleUrl(),
          center: [34.94, 32.03],
          zoom: 8.6,
          attributionControl: false,
        });

        this.map.on('load', () => {
          this.map.resize();
          this.zoom = this.map.getZoom();
          const transFormedbranchesMapLocationsList =
            this.branchesMapLocationsList.sort((a, b) => b.top - a.top);
          transFormedbranchesMapLocationsList.forEach((branch) => {
            const location = branch.location;
            const name = branch.name;
            const el = document.createElement('div');
            el.className = 'custom-marker';
            el.innerHTML = `<div style="display: flex; flex-direction: column; align-items: center; cursor: pointer">
                     <div class="marker-label" style="background:rgba(255, 255, 255, 0.85); font-size:12px; color:#26a69a; border-radius: 13px; padding: 0 6px; font-size: 13px; margin-bottom: 2px; cursor: pointer;">
                       ${this.translate.instant(
              'choose-branch.naming.' + name
            )}
                     </div>
                   </div>`;
            const marker = new maplibregl.Marker({ element: el })
              .setLngLat([location.lon, location.lat])
              .addTo(this.map);
            this.markerElements.push(el);
            el.addEventListener('click', () => {
              this.clusterName = branch.name;
              this.onSetCluster();
            });
          });
          this.updateZoom();
          this.map.on('zoom', () => {
            this.updateZoom();
          });
        });

        this.map.zoomTo(this.zoom, { duration: 1000 });
        if (this.map) this.map.resize();
      }, 0);
      setTimeout(() => {
        this.updateMarkerLabels();
      }, 0);
      this.translate.onLangChange.subscribe(() => {
        setTimeout(() => {
          this.updateMarkerLabels();
        }, 0);
      });
    }

    this.fullHeight = window.innerHeight;
    setTimeout(() => {
      // scroll scrollContainer to top
      if (this.scrollContainer) {
        this.scrollContainer.nativeElement.scrollTop = 0;
      }
    }, 0);
  }

  updateMarkerLabels() {
    this.branchesMapLocationsList.forEach((branch, i) => {
      const name = branch.name;
      const el = this.markerElements[i];
      if (el) {
        const label = el.querySelector('.marker-label');
        if (label) {
          label.innerHTML = this.translate.instant(
            'choose-branch.naming.' + name
          );
        }
      }
    });
  }

  onSetCluster() {
    if (this.clusterName !== '') {
      this.dataSharingService.setCluster(this.clusterName);
      this.router.navigate(['/branch']);
    }
  }

  updateZoom() {
    const zoom = this.map.getZoom();
    this.zoom = zoom;
    const markers = document.querySelectorAll('.custom-marker');
    this.branchesMapLocationsList.forEach((branch, i) => {
      const marker = markers[i] as HTMLElement;
      if (marker) {
        const timming = branch.time ? branch.time : 10;
        const padding =
          zoom > timming + 6
            ? 0
            : zoom < timming
              ? branch.top
              : branch.top - (zoom - timming) * branch.top;
        marker.style.paddingTop = `${padding}px`;
      }
    });
  }

  showTryNowBtn = false;

  ngAfterViewChecked() {
    if (
      this.hoverService !== '' &&
      this.serviceExplainText.length === this.completeServiceExplainText.length &&
      !this.showTryNowBtn
    ) {
      setTimeout(() => {
        this.showTryNowBtn = true;
      }, 10); // דחייה קצרה כדי לאפשר לכפתור להיכנס ל־DOM
    } else if (
      (this.hoverService === '' ||
        this.serviceExplainText.length !== this.completeServiceExplainText.length) &&
      this.showTryNowBtn
    ) {
      this.showTryNowBtn = false;
    }
  }

  ngOnDestroy() {
    if (this.directionSubscription) {
      this.directionSubscription.unsubscribe();
    }
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    // if (!this.isIphone()) {
    //   document.removeEventListener('click', this.playVideo);
    // }
  }

  getLang() {
    if (this.isRTL) {
      return 'he';
    }
    return 'en';
  }

  typeDeviceText(newDevice: string) {
    if (this.typing) {
      return;
    }

    this.typing = true;

    // Choose the right key based on mode
    const keyPrefix = this.isBusinessMode ? 'about-us.business-title-2.' : 'about-us.main-title-2.';
    const key = keyPrefix + newDevice;

    this.translate.stream(key).pipe(
      filter((translatedText: string) => translatedText !== key)
    ).subscribe((translatedText: string) => {

      const delete$ = timer(0, 40).pipe(
        take(this.typedText.length),
        map(() => this.typedText.slice(0, -1))
      );

      const type$ = timer(0, 40).pipe(
        take(translatedText.length),
        map((i: number) => translatedText.slice(0, i + 1))
      );

      concat(delete$, type$).subscribe(
        (text: string) => this.typedText = text,
        null,
        () => this.typing = false
      );
    });

    const keyDevice = 'about-us.devices-explain-1.' + newDevice;

    this.translate.stream(keyDevice).pipe(
      filter((translatedText: string) => translatedText !== keyDevice)
    ).subscribe((translatedText: string) => {

      const delete$ = timer(0, 40).pipe(
        take(this.typedTextDevice.length),
        map(() => this.typedTextDevice.slice(0, -1))
      );

      const type$ = timer(0, 40).pipe(
        take(translatedText.length),
        map((i: number) => translatedText.slice(0, i + 1))
      );

      concat(delete$, type$).subscribe(
        (text: string) => this.typedTextDevice = text,
        null,
        () => this.typing = false
      );
    });
  }

  goHome() {
    this.router.navigate(['/']);
  }

  goToQAndA() {
    this.router.navigate(['/qanda']);
  }


  startStepsAnimation() {
    this.isAnimatingSteps = true;
    this.animationInterval = setInterval(() => {
      if (this.isAnimatingSteps) {
        this.animatingStep++;
      }
    }, 333);
  }

  forceReflow() {
    // Get the elements
    const elements = document.querySelectorAll('.step-1, .step-2, .step-3');
    // Force a reflow on each element
    elements.forEach((element: Element) => {
      void (element as HTMLElement).offsetWidth;
    });
  }

  stopStepsAnimation() {
    this.isAnimatingSteps = false;
    clearInterval(this.animationInterval);
    this.animatingStep = 0;
  }

  getHeightForAnimation(): number {
    if (this.fullHeight < 667) {
      return this.fullHeight + this.scrollTop;
    } else {
      return 667 + ((this.fullHeight - 667) * 0.62) + this.scrollTop;
    }
  }

  isIphone(): boolean {
    return /iPhone/.test(navigator.userAgent);
  }

  // new!

  steps: any[] = [
    {
      name: 'upload',
      icon: 'cloud_upload',
      index: 1,
      color: 'green'
    },
    {
      name: 'print',
      icon: 'print',
      index: 2,
      color: 'pink'
    },
    {
      name: 'collect',
      icon: 'collections',
      index: 3,
      color: 'green'
    }
  ];

  getSteps() {
    return this.steps;
  }

  advantages: any[] = [
    {
      name: 'available',
      index: 1,
      color: 'pink'
    },
    {
      name: 'fast',
      index: 2,
      color: 'green'
    },
    {
      name: 'accurate',
      index: 3,
      color: 'pink'
    },
    {
      name: 'secure',
      index: 4,
      color: 'green'
    },
    {
      name: 'service',
      index: 5,
      color: 'pink'
    }
  ];

  getAdvantages() {
    return this.advantages;
  }

  hoverService: string = '';
  hoverTimerSubscription: Subscription;
  startDeviceTimer() {
    // Stop any existing timer first
    this.stopDeviceTimer();
    
    this.hoverTimerSubscription = timer(0, 4000).subscribe(() => {
      // Choose devices based on mode
      // In home mode: use doc, img, sketch (for "להדפיס מסמכים", "לפתח תמונות", "להדפיס שרטוטים")
      // In business mode: use express, pics, plotter (for "עמדת מסמכים", "עמדת תמונות", "עמדת פלוטר")
      const activeDevices = this.isBusinessMode ? this.services : this.devices;
      // Reset index if it's out of bounds
      if (this.deviceIndex >= activeDevices.length) {
        this.deviceIndex = 0;
      }
      // Use current index first, then increment
      const currentDevice = activeDevices[this.deviceIndex];
      this.deviceIndex = (this.deviceIndex + 1) % activeDevices.length;
      this.imgDevice = currentDevice;
      
      if (this.isBusinessMode) {
        // Business mode: use services directly (express, pics, plotter)
        this.imgService = currentDevice;
      } else {
        // Home mode: map doc/img/sketch to express/pics/plotter for images
        if (currentDevice === 'doc') {
          this.imgService = 'express';
        } else if (currentDevice === 'img') {
          this.imgService = 'pics';
        } else if (currentDevice === 'sketch') {
          this.imgService = 'plotter';
        } else {
          this.imgService = currentDevice;
        }
      }
      this.typeDeviceText(currentDevice);
    });
  }

  stopDeviceTimer() {
    if (this.hoverTimerSubscription) {
      this.hoverTimerSubscription.unsubscribe();
      this.hoverTimerSubscription = null;
    }
  }

  serviceExplainInterval: any = null;
  completeServiceExplainText: string = '';
  serviceExplainText: string = '';
  isServiceExplainTextCompleted: boolean = false;
  onServiceHover(service: string, isForce: boolean = false) {
    if (!this.isScreenWide && !isForce) return;
    this.stopDeviceTimer();
    this.hoverService = service;
    this.serviceExplainText = '';
    this.completeServiceExplainText = this.translate.instant('about-us.station-exp-more-' + service);

    // נקה interval קודם אם קיים
    if (this.serviceExplainInterval) {
      clearInterval(this.serviceExplainInterval);
      this.serviceExplainInterval = null;
    }

    console.log('scrollContainer', this.scrollContainer);
    // Don't auto-scroll if business form is open
    if (this.scrollContainer && this.isScreenWide && !this.showBusinessForm) {
      this.scrollContainer.nativeElement.scrollTop = 0;
    }

    let i = 0;
    this.serviceExplainInterval = setInterval(() => {
      if (i < this.completeServiceExplainText.length) {
        this.serviceExplainText = this.completeServiceExplainText.slice(0, i + 1);
        i++;
        if (i === this.completeServiceExplainText.length) {
          setTimeout(() => {
            this.isServiceExplainTextCompleted = true;
          }, 120);
        }
      } else {
        clearInterval(this.serviceExplainInterval);
        this.serviceExplainInterval = null;
      }
    }, 20);
  }

  onServiceLeave(isForce: boolean = false) {
    if (!this.isScreenWide && !isForce) return;
    this.startDeviceTimer();
    this.hoverService = '';
    if (this.serviceExplainInterval) {
      clearInterval(this.serviceExplainInterval);
      this.serviceExplainInterval = null;
    }
    this.isServiceExplainTextCompleted = false;
    this.serviceExplainText = '';
  }

  // GOTO

  goToFB() {
    window.open('https://www.facebook.com/eazix.il/', '_blank');
  }
  goToInstagram() {
    window.open('https://www.instagram.com/eazix.io/', '_blank');
  }

  openWhatsApp() {
    const phoneNumber = '97233746962';
    let message = 'Hi Eazix, I need some help printing :)';
    
    // In business mode (JOIN US), use different message
    if (this.isBusinessMode) {
      message = 'Join-Eazix-Today';
    }
    
    const encodedMessage = encodeURIComponent(message);
    const url = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(url, '_blank');
  }
  // ================================
  
  // Business form functions
  initBusinessForm() {
    this.businessForm = new FormGroup({
      email: new FormControl(this.userEmail || '', [Validators.required, Validators.email]),
      phone: new FormControl(this.userPhone || '', [Validators.required, this.phoneValidator]),
      iAm: new FormControl('', [Validators.required]),
      iAmOtherText: new FormControl(''),
      aboutYou: new FormControl('', [Validators.required, Validators.minLength(3)])
    });
    
    // Add conditional validation for iAmOtherText
    this.businessForm.get('iAm').valueChanges.subscribe(value => {
      if (value === 'other') {
        this.businessForm.get('iAmOtherText').setValidators([Validators.required, Validators.minLength(3)]);
      } else {
        this.businessForm.get('iAmOtherText').clearValidators();
        this.businessForm.get('iAmOtherText').setValue('');
      }
      this.businessForm.get('iAmOtherText').updateValueAndValidity();
    });
  }
  
  phoneValidator(control: AbstractControl): { [key: string]: any } | null {
    if (!control.value) {
      return { required: true };
    }
    const phoneStr = typeof control.value === 'string' ? control.value : control.value.toString();
    const digitsOnly = phoneStr.replace(/\D/g, '');
    const valid = digitsOnly.length === 10;
    return valid ? null : { invalidPhone: { valid: false, value: control.value } };
  }
  
  formatPhoneNumber(phoneNumber: number): string {
    if (!phoneNumber) {
      return '';
    }
    const str = '0' + phoneNumber.toString();
    return str.slice(0, 3) + '-' + str.slice(3, 7) + '-' + str.slice(7);
  }
  
  toggleBusinessForm() {
    this.showBusinessForm = !this.showBusinessForm;
    
    // If opening the form, initialize it if needed and load user data
    if (this.showBusinessForm) {
      if (!this.businessForm) {
        this.initBusinessForm();
      }
      this.loadUserDataToForm();
    }
  }
  
  loadUserDataToForm() {
    if (!this.businessForm) {
      return;
    }
    
    // Check if user is authenticated
    const isAuth = this.authService.getIsAuth();
    
    if (isAuth) {
      // Get user email and phone from UsersService (more reliable for FB/Google users)
      const userId = this.authService.getUserId();
      if (userId) {
        this.usersService.getUser(userId).pipe(take(1)).subscribe((user: any) => {
          if (user) {
            // Get email - prefer user.email from database (works for all providers)
            if (user.email) {
              this.userEmail = user.email;
              this.businessForm.patchValue({ email: this.userEmail });
            }
            
            // Get phone
            if (user.phone) {
              // Format phone number with leading 0 (formatPhoneNumber already adds 0)
              this.userPhone = this.formatPhoneNumber(user.phone);
              this.businessForm.patchValue({ phone: this.userPhone });
            }
            // If no phone, leave field empty (don't clear it if user already typed something)
          }
        });
      } else {
        // Fallback to AuthService email if userId not available
        this.authService.email$.pipe(take(1)).subscribe(email => {
          if (email) {
            this.userEmail = email;
            this.businessForm.patchValue({ email: this.userEmail });
          }
        });
      }
    } else {
      // User not authenticated, clear fields
      this.userEmail = '';
      this.userPhone = '';
      this.businessForm.patchValue({ email: '', phone: '' });
    }
  }
  
  scrollToTopAndOpenForm() {
    console.log('scrollToTopAndOpenForm called');
    
    const targetPosition = 400;
    let scrollElement: HTMLElement | null = null;
    
    // Try scrolling the scrollContainer if it exists
    if (this.scrollContainer && this.scrollContainer.nativeElement) {
      console.log('Using scrollContainer');
      scrollElement = this.scrollContainer.nativeElement;
      scrollElement.scrollTo({ top: targetPosition, behavior: 'smooth' });
    } else {
      // Fallback to window scroll
      console.log('Using window scroll');
      window.scrollTo({ top: targetPosition, behavior: 'smooth' });
      document.documentElement.scrollTo({ top: targetPosition, behavior: 'smooth' });
      document.body.scrollTo({ top: targetPosition, behavior: 'smooth' });
    }
    
    // Function to check if scroll is complete
    let checkCount = 0;
    const maxChecks = 200; // Prevent infinite loop
    const scrollThreshold = 10; // Consider "close enough" if within 10px
    
    const checkScrollComplete = () => {
      checkCount++;
      
      let currentScroll = 0;
      if (scrollElement) {
        currentScroll = scrollElement.scrollTop;
      } else {
        currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      }
      
      const distanceFromTarget = Math.abs(currentScroll - targetPosition);
      
      if (distanceFromTarget <= scrollThreshold || checkCount >= maxChecks) {
        // Scroll is complete, wait 10ms and open the form
        setTimeout(() => {
          if (!this.showBusinessForm) {
            this.showBusinessForm = true;
            // Initialize form if needed and load user data when opening the form
            if (!this.businessForm) {
              this.initBusinessForm();
            }
            this.loadUserDataToForm();
          }
        }, 10);
      } else {
        // Continue checking
        requestAnimationFrame(checkScrollComplete);
      }
    };
    
    // Start checking after a short delay to allow scroll to begin
    setTimeout(() => {
      requestAnimationFrame(checkScrollComplete);
    }, 50);
  }
  
  onSubmitBusinessForm() {
    if (this.isSubmittingForm) {
      return;
    }
    
    // Check if form is invalid
    if (!this.businessForm || this.businessForm.invalid) {
      // Show message for 2 seconds
      this.showFieldsNotCompleteMessage = true;
      
      // Clear any existing timeout
      if (this.fieldsNotCompleteTimeout) {
        clearTimeout(this.fieldsNotCompleteTimeout);
      }
      
      // Hide message after 2 seconds
      this.fieldsNotCompleteTimeout = setTimeout(() => {
        this.showFieldsNotCompleteMessage = false;
      }, 2000);
      
      return;
    }
    
    // 1. Start submitting - show spinner and lock fields
    this.isSubmittingForm = true;
    
    const formData = {
      email: this.businessForm.value.email,
      phone: this.businessForm.value.phone,
      iAm: this.businessForm.value.iAm,
      iAmOtherText: this.businessForm.value.iAmOtherText || '',
      aboutYou: this.businessForm.value.aboutYou
    };
    
    // Get translated "I am" value
    let iAmText = '';
    if (formData.iAm === 'business-owner') {
      iAmText = this.translate.instant('about-us.business-form-i-am-business-owner');
    } else if (formData.iAm === 'student') {
      iAmText = this.translate.instant('about-us.business-form-i-am-student');
    } else if (formData.iAm === 'other') {
      iAmText = formData.iAmOtherText || this.translate.instant('about-us.business-form-i-am-other');
    }
    
    // Title: "פניה להצבת עמדה מ- " + email + " | " + phone
    const title = this.translate.instant('about-us.business-form-log-title') + ' ' + formData.email + ' | ' + formData.phone;
    
    // Content: aboutYou + " | " + iAm + " | " + email + " | " + phone
    const content = formData.aboutYou + ' | ' + iAmText + ' | ' + formData.email + ' | ' + formData.phone;
    
    // Console.log with Hebrew field names as specified in requirements
    const requestData = {
      כותרת: title,
      תוכן: content
    };
    console.log('Request data:', requestData);
    
    // Send to endpoint
    const url = environment.apiUrl + '/api/update/partnership-interest';
    const requestBody = {
      subject: title,  // השדה 'כותרת' -> 'subject'
      content: content  // השדה 'תוכן' -> 'content'
    };
    
    this.http.post<{ message: string; sentCount: number; totalEmails: number }>(url, requestBody)
      .subscribe(
        (response) => {
          console.log('Email sent successfully:', response);
          // response = { message: 'SUCCESS', sentCount: 2, totalEmails: 2 }
          
          // 2.1 Measure form height
          if (this.businessFormContainer && this.businessFormContainer.nativeElement) {
            this.formContainerHeight = this.businessFormContainer.nativeElement.offsetHeight;
          }
          
          // 2.2 After 10ms - hide button, set min-height, hide form, show success
          setTimeout(() => {
            this.isSubmittingForm = false;
            this.showSuccessMessage = true;
            this.playSuccessAnimation();
            
            // 2.3 After 4000ms - reset to initial state
            this.successTimeout = setTimeout(() => {
              this.resetFormToInitialState();
            }, 4000);
          }, 10);
        },
        (error) => {
          // According to requirements, this should not happen - always positive response
          console.error('Error sending partnership interest:', error);
          this.isSubmittingForm = false;
        }
      );
  }
  
  playSuccessAnimation() {
    if (this.animation) {
      this.animation.play();
    }
  }
  
  resetFormToInitialState() {
    // Clear timeout if exists
    if (this.successTimeout) {
      clearTimeout(this.successTimeout);
      this.successTimeout = null;
    }
    
    // Reset states
    this.showSuccessMessage = false;
    this.isSubmittingForm = false;
    this.showFieldsNotCompleteMessage = false;
    this.formContainerHeight = 0;
    
    // Clear fields not complete timeout
    if (this.fieldsNotCompleteTimeout) {
      clearTimeout(this.fieldsNotCompleteTimeout);
      this.fieldsNotCompleteTimeout = null;
    }
    
    // Reset form - clear all fields except email and phone if user has them
    if (this.businessForm) {
      this.businessForm.patchValue({
        iAm: '',
        iAmOtherText: '',
        aboutYou: ''
      });
      // Keep email and phone if user has them (they are already set in loadUserDataToForm)
    }
    
    // Close form
    this.showBusinessForm = false;
    
    // Stop animation if playing
    if (this.animation) {
      this.animation.stop();
    }
  }
}

